module.exports = {"data":{"site":{"siteMetadata":{"title":"Jorge Mancheno, Product Designer","author":"Jorge Mancheno","description":"Jorge Mancheno is a product designer and front-end developer based in Brooklyn, NY.","siteUrl":"https://jorgemancheno.com","email":"hello@jorgemancheno.com","dribbbleUrl":"https://dribbble.com/jorgemancheno","githubUrl":"https://github.com/jorgemancheno","twitterUrl":"https://twitter.com/jorgemancheno","twitterHandle":"@jorgemancheno"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 122
// module chunks = 60335399758886 114276838955818